module.exports = __webpack_public_path__ + "static/img/menageService1.58d090aa.png";